<template>
  <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px;">
    <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
      <div class="loading-img"></div>
    </div>
  </div>

  <div class="wrapper" v-show="!viewMore.show">
    <div class="search-header">
      <div class="search-header-text"> 初步尽调信息</div>
    </div>

    <div class="search-company-box">
      <!-- 公司信息 -->
      <div class="dhy-details-box" style="margin-top:0.5rem;" v-if="company && !loading">
        <div class="dhy-list-box">
          <ul>
            <li><p class="date">证券简称</p><p class="time">{{ company.shortname }}</p></li>
            <li><p class="date">证券代码</p><p class="time">{{ company.code }}</p></li>
            <li><p class="date">公司全称</p><p class="time">{{ company.companyname }}</p></li>
            <li><p class="date">所属交易所、板块</p><p class="time">{{ company.plate | plate }}</p></li>
          </ul>
        </div>
      </div>

      <!-- 融入方基本信息 -->
      <div class="dhy-details-box" v-if="pledgor && !loading">
        <h3 class="">融入方基本信息</h3>
          <div class="dhy-list-box">
            <ul>
              <li>
                <p class="date">股东名称</p>
                <p class="time" v-if="pledgor.holder">{{pledgor.holder.name}}</p>
                <p class="time" v-else>{{intoPerson}}</p>
              </li>
              <li>
                <p class="date">股东性质</p>
                <p class="time" v-if="pledgor.holder.holdertyp">{{pledgor.holder.holdertyp}}</p>
                <p class="time" v-else>--</p>
              </li>
              <li>
                <p class="date">持股数量（万股）</p>
                <p class="time"  v-if="pledgor.holder.quantity">{{pledgor.holder.quantity / 10000 | money}}</p>
                <p class="time"  v-else>--</p>
              </li>
              <li><p class="date">持股比例</p>
                <p class="time" v-if="pledgor.holder.ratio">{{ parseFloat(pledgor.holder.ratio) }}%</p>
                <p v-else>--</p>
              </li>
              <li>
                <p class="date">持有有限售条件的股份数量(万股)</p>
                <p class="time" v-if="pledgor.holder.limitedquantity">{{pledgor.holder.limitedquantity/ 10000 | money}}</p>
                <p v-else>--</p>
              </li>
              <li v-if="pledgor.executive.job">
                <p class="date">董监高</p>
                <p class="time">{{pledgor.executive.job}}</p>
              </li>
            </ul>
         </div>
      </div>

      <!-- 融入方近三年监管及处罚信息 -->
      <div class="pledge-list-box1" v-if="showpledgor && !loading">
        <ul>
          <li class="active">融入方近三年监管及处罚信息</li>
          <li class="title">证监会</li>
            <li>
              <p class="date">行政处罚</p>
              <p class="time" v-if="pledgorNoticeInfo.xzcf.total > 0">
                <a class="info-Underline" @click.self="goNotice(pledgorNoticeInfo.xzcf.lists[0]), setCnzz('查看公告', '点击查看行政处罚公告', '')">{{pledgorNoticeInfo.xzcf.lists[0].title}}</a>
                <span class="External-date">{{pledgorNoticeInfo.xzcf.lists[0].publishDate}}</span>
                <a class="more-right" style="cursor:pointer" v-if="pledgorNoticeInfo.xzcf.total > 1" @click.self="showlists(pledgorNoticeInfo.xzcf.lists), setCnzz('查看更多', '点击查看更多', '')">更多&gt;</a>
              </p>
              <p class="time" v-else>--</p>
            </li>
            <li>
              <p class="date">立案调查</p>
              <p class="time" v-if="pledgorNoticeInfo.ladc.total > 0">
                <a class="info-Underline" @click.self="goNotice(pledgorNoticeInfo.ladc.lists[0]), setCnzz('查看公告', '点击查看立案调查公告', '')">{{pledgorNoticeInfo.ladc.lists[0].title}}</a>
                <span class="External-date">{{pledgorNoticeInfo.ladc.lists[0].publishDate}}</span>
                <a class="more-right" style="cursor:pointer" v-if="pledgorNoticeInfo.ladc.total > 1" @click.self="showlists(pledgorNoticeInfo.ladc.lists), setCnzz('查看更多', '点击查看更多', '')">更多&gt;</a>
              </p>
              <p class="time" v-else>--</p>
            </li>
            <li>
              <p class="date">监管措施</p>
              <p class="time" v-if="pledgorNoticeInfo.jgcszjh.total > 0">
                <a class="info-Underline" @click.self="goNotice(pledgorNoticeInfo.jgcszjh.lists[0]), setCnzz('查看公告', '点击查看监管措施公告', '')">{{pledgorNoticeInfo.jgcszjh.lists[0].title}}</a>
                <span class="External-date">{{pledgorNoticeInfo.jgcszjh.lists[0].publishDate}}</span>
                <a class="more-right" style="cursor:pointer" v-if="pledgorNoticeInfo.jgcszjh.total > 1" @click.self="showlists(pledgorNoticeInfo.jgcszjh.lists), setCnzz('查看更多', '点击查看更多', '')">更多&gt;</a>
              </p>
              <p class="time" v-else>--</p>
            </li>
            <li>
              <p class="date">市场禁入</p>
              <p class="time" v-if="pledgorNoticeInfo.scjr.total > 0">
                <a class="info-Underline" @click.self="goNotice(pledgorNoticeInfo.scjr.lists[0]), setCnzz('查看公告', '点击查看市场禁入公告', '')">{{pledgorNoticeInfo.scjr.lists[0].title}}</a>
                <span class="External-date">{{pledgorNoticeInfo.scjr.lists[0].publishDate}}</span>
                <a class="more-right" style="cursor:pointer" v-if="pledgorNoticeInfo.scjr.total > 1" @click.self="showlists(pledgorNoticeInfo.scjr.lists), setCnzz('查看更多', '点击查看更多', '')">更多&gt;</a>
              </p>
              <p class="time" v-else>--</p>
            </li>
          <li class="title">交易所</li>
            <li>
              <p class="date">监管问询</p>
              <p class="time" v-if="pledgorNoticeInfo.jgwx.total > 0">
                <a class="info-Underline" @click.self="goNotice(pledgorNoticeInfo.jgwx.lists[0]), setCnzz('查看公告', '点击查看监管问询公告', '')">{{pledgorNoticeInfo.jgwx.lists[0].title}}</a>
                <span class="External-date">{{pledgorNoticeInfo.jgwx.lists[0].publishDate}}</span>
                <a class="more-right" style="cursor:pointer" v-if="pledgorNoticeInfo.jgwx.total > 1" @click.self="showlists(pledgorNoticeInfo.jgwx.lists), setCnzz('查看更多', '点击查看更多', '')">更多&gt;</a>
              </p>
              <p class="time" v-else>--</p>
            </li>
            <li>
              <p class="date">监管措施</p>
              <p class="time" v-if="pledgorNoticeInfo.jgcs.total > 0">
                <a class="info-Underline" @click.self="goNotice(pledgorNoticeInfo.jgcs.lists[0]), setCnzz('查看公告', '点击查看监管措施公告', '')">{{pledgorNoticeInfo.jgcs.lists[0].title}}</a>
                <span class="External-date">{{pledgorNoticeInfo.jgcs.lists[0].publishDate}}</span>
                <a class="more-right" style="cursor:pointer" v-if="pledgorNoticeInfo.jgcs.total > 1" @click.self="showlists(pledgorNoticeInfo.jgcs.lists), setCnzz('查看更多', '点击查看更多', '')">更多&gt;</a>
              </p>
              <p class="time" v-else>--</p>
            </li>
        </ul>
      </div>

      <!-- 融入方最新质押信息 -->
      <div class="dhy-details-box" v-if="pledge.notice && !loading">
        <h3 class="">融入方最新质押信息</h3>

        <div class="search-result-list" v-if="pledge.notice">
          <p class="head">
            <span class="xsl-icon"></span>
            <a href="javascript:;" @click="goNotice(pledge.notice)">{{ pledge.notice.title }}</a>
          </p>
          <p class="Subtitle">
            <span class="fl">证券代码：2520008</span>
            <span class="fr">{{ pledge.notice.publishDate}}</span>
          </p>
          <template v-if="pledge.notice.child" v-for="child in pledge.notice.child">
            <!--标题-->
            <p class="blak font-weight lien child-title" :style="indentChild(child.code)" @click="viewStockTitle(pledge.notice, child.code)">
              {{{ child.title }}}
            </p>

            <!--段落内容-->
            <p class="lien" :style="indentChild(child.code)" v-if="child.content">
                {{{ child.content.join('...... ') }}}
            </p>
            <template v-for="c in child.contents" v-if="child.contents">
              <p class="lien" :style="indentChild(child.code)" v-if="c.htmltag=='p'">
                  {{{ c.content }}}</br>
              </p>
              <template v-if="c.htmltag=='table'">
                <!--表格-->
                <div class="table-result-main">
                  <table cellpadding="0" class="table-result-dhy">
                     <tbody>
                       <tr v-for="(rowidx, row) in c.table" track-by="$index" :class="{'oldcom': !(rowidx%2), 'evencom': rowidx%2}">
                         <td v-for="(colidx, col) in row" rowspan="{{ col.row }}" colspan="{{ col.col }}" track-by="$index"> {{{col.value}}} </td>
                       </tr>
                     </tbody>
                  </table>
                </div>
                <div class="table-whole">
                  <ul>
                    <li>
                      <a href="javascript:;" @click="viewStockTable(pledge.notice, child.code, c.offset)">
                        <span class="search-icon small-table"></span>查看表格全部内容
                      </a>
                    </li>
                  </ul>
                </div>
              </template>
            </template>
          </template>
        </div>
      </div>

      <!-- 历史质押信息 -->
      <div class="dhy-details-box lszy-box">
        <h3 class="" v-show="mergePledge.length>0">历史质押信息</h3>
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <!-- <div class="swiper-slide"></div> -->
            <div class="pledge-list-box swiper-slide" v-for="(index, h) in mergePledge" track-by="$index">
              <ul>
                <li>
                  <p class="date">股东名称</p>
                  <p class="time">{{ h.name_of_shareholder  | nullVal }}</p>
                </li>
                <li>
                  <p class="date">是否为第一大股东及一致行动人</p>
                  <p class="time">{{ h.whether_the_largest_shareholder_and_concerted_action  | nullVal }}</p>
                </li>
                <li>
                  <p class="date">股数(股)</p>
                  <p class="time">{{ h.pledge_nums | money | nullVal }}</p>
                </li>
                <li>
                  <p class="date">股份性质</p>
                  <p class="time">{{ h.pledge_of_shares_in_nature | nullVal }}</p>
                </li>
                <li>
                  <p class="date">开始日期</p>
                  <p class="time">{{ h.pledge_start_date  | nullVal }}</p>
                </li>
                <li>
                  <p class="date">结束日期</p><p class="time">{{ h.pledge_due_date  | nullVal }}</p>
                </li>
                <li>
                  <p class="date">延期后结束日期</p>
                  <p class="time">{{ h.after_the_expiration_of_the_pledge_due_date  | nullVal }}</p>
                </li>
                <li>
                  <p class="date">解除日期</p><p class="time">{{h.release_pledge_date  | nullVal}}</p>
                </li>
                <li>
                  <p class="date">本次质押占其所持股份比例(%)</p>
                  <p class="time">{{ h.the_pledge_of_its_shareholding_ratio  | nullVal }}</p>
                </li>
                <li>
                  <p class="date">用途</p>
                  <p class="time">{{ h.use  | nullVal }}</p>
                </li>
                <li>
                  <p class="date">质权人</p>
                  <p class="time">{{ h.pledgee  | nullVal }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>

      <!-- 累计质押 -->
      <!-- <div class="dhy-details-box ljzy-box" v-if="cumulative_pledge.length > 0"> -->
      <div class="dhy-details-box ljzy-box">
        <h3 class="" v-show="cumulative_pledge.length > 0">累计质押</h3>
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="pledge-list-box swiper-slide" v-for="(index, h) in cumulative_pledge" track-by="$index">
              <ul>
                <li>
                  <p class="date">股东名称</p>
                  <p class="time">{{ h.holder_name | nullVal}}</p>
                </li>
                <li>
                  <p class="date">公司总股本</p>
                  <p class="time">{{ h.company_share_capital | money | nullVal }}</p>
                </li>
                <li>
                  <p class="date">累计质押数</p>
                  <p class="time">{{ h.cumulative_pledge | money | nullVal }}</p>
                </li>
                <li>
                  <p class="date">累计质押数占总股本</p>
                  <p class="time">{{ h.cumulative_pledge_proportion_of_total_capital | percent | nullVal }}</p>
                </li>
                <li>
                  <p class="date">累计质押数占持有股</p>
                  <p class="time">{{ h.cumulative_pledge_proportion_of_shares_held | percent | nullVal }}</p>
                </li>

                <li>
                  <p class="date">累计质押非限售股</p>
                  <p class="time">{{ h.cumulative_pledge_unlimited_selling_shares | money | nullVal }}</p>
                </li>
                <li>
                  <p class="date">累计质押限售股</p>
                  <p class="time">{{ h.cumulative_pledge_limited_selling_shares | money | nullVal }}</p>
                </li>
                <li>
                  <p class="date">持有股数</p>
                  <p class="time">{{ h.shares_held | money | nullVal }}</p>
                </li>
                <li>
                  <p class="date">持有股数占总股本</p>
                  <p class="time">{{ h.shares_held_proportion_of_total_capital | percent | nullVal }}</p>
                </li>
                <li>
                  <p class="date">持有非限售股数</p>
                  <p class="time">{{ h.shares_held_unlimited_selling | money | nullVal }}</p>
                </li>

                <li>
                  <p class="date">持有限售股数</p>
                  <p class="time">{{ h.shares_held_limited_selling | money | nullVal }}</p>
                </li>
                <li>
                  <p class="date">直接持股数</p>
                  <p class="time">{{ h.shares_held_directly | money | nullVal }}</p>
                </li>
                <li>
                  <p class="date">直接持股数占总股本</p>
                  <p class="time">{{ h.shares_held_directly_proportion_of_total_capital | percent | nullVal }}</p>
                </li>
                <li>
                  <p class="date">发布日期</p>
                  <p class="time">{{ h.publishdate | nullVal }}</p>
                </li>
             </ul>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <!-- <div class="width: 100%;" v-if="cumulative_pledge.length > 0"> -->
      <div class="rate-chart-wrap" v-if="cumulative_pledge.length > 0">
        <div class="analyze-chart-box3" style="width: 100%;">
          <div class="rate-chart3" style="height:150px;width:100%;border:1px solid rgb(232, 238, 245);margin-bottom:10px;"></div>
        </div>
      </div>

      <!-- 全市场质押情况 -->
      <div class="pledge-box1" v-if="pledge">
        <h3 class="">
          全市场质押情况
          <span style="color: #333;">（截止  {{pledge.rate.updtime.slice(0,10)}}）</span>
        </h3>
        <div class="pledge-list-box1">
          <ul>
            <li>
              <p class="date">证券代码</p>
              <p class="time">{{pledge.rate.stock_code}}</p>
            </li>
            <li>
              <p class="date">证券简称</p>
              <p class="time">{{pledge.rate.securities_abbreviation}}</p>
            </li>
            <li>
              <p class="date">质押笔数(笔)</p>
              <p class="time">{{pledge.rate.pledge_count}}</p>
            </li>
            <li>
              <p class="date">无限售股份质押数量(万)</p>
              <p class="time">{{pledge.rate.unlimited_number_of_shares_pledged | money}}</p>
            </li>
            <li>
              <p class="date">有限售股份质押数量(万)</p>
              <p class="time">{{pledge.rate.limited_number_of_shares_pledged_shares | money}}</p>
            </li>
            <li>
              <p class="date">A股总股本(万)</p>
              <p class="time">{{pledge.rate.total_share_capital | money}}</p>
            </li>
            <li>
              <p class="date">质押比例（%）</p>
              <p class="time">{{parseFloat(pledge.rate.pledge_ratio)}}</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 质押比率 -->
      <div class="rate-chart-wrap" v-show="rate_company.dataX.length>0">
        <p class="a-text">全场质押比例</p>
        <div class="analyze-chart-box" style="width: 100%;">
          <div id="rate-chart" style="height:180px;width:100%;border:1px solid rgb(232, 238, 245);margin-bottom:10px;"></div>
        </div>
      </div>
      <!-- 上交所/深交所 质押比率 -->
      <div class="rate-chart-wrap" v-show="rate_szse.dataX.length>0 || rate_shse.dataX.length>0">
        <p class="a-text" v-show="rate_shse.dataX.length>0">上交所平均质押率</p>
        <p class="a-text" v-show="rate_szse.dataX.length>0">深交所平均质押率</p>
        <div class="analyze-chart-box2" style="width: 100%;">
          <div id="rate-chart2" style="height:180px;width:100%;border:1px solid rgb(232, 238, 245);margin-bottom:10px;"></div>
        </div>
      </div>

      <!-- 标的证券基本情况 -->
      <div class="dhy-details-box" v-if="showcompany || stock">
        <h3 class="">标的证券基本情况</h3>
        <div class="pledge-list-box">
          <ul>
            <li>
              <p class="date" v-if="!checkProperty(stock.risk)">ST</p>
              <p class="date" v-if="checkProperty(stock.risk)">存在退市风险</p>
              <template v-if="!checkProperty(stock.risk)">
                <p class="time" v-if="stock.risk.qita">是</p>
                <p class="time" v-else>--</p>
              </template>
              <template v-if="checkProperty(stock.risk)">
                <p class="time" v-if="stock.risk.ctuishi">是</p>
                <p class="time" v-else>--</p>
              </template>
            </li>
            <li>
              <p class="date">*ST</p>
              <p class="time" v-if="stock.risk.tuishi">--</p>
              <p class="time" v-else>--</p>
            </li>
            <li>
              <p class="date">暂停上市</p>
              <p class="time" v-if="stock.risk.zanting">
                <a class="info-Underline" @click="goNotice(stock.risk.zanting), setCnzz('查看公告', '点击查看暂停上市公告', '')">{{stock.risk.zanting.title}}</a>
                <span class="External-date">{{stock.risk.zanting.publishdate}}</span>
              </p>
              <p class="time" v-else>--</p>
            </li>
            <li>
              <p class="date">退市整理期</p>
              <p class="time" v-if="stock.risk.zhengli">
                <a class="info-Underline" @click="goNotice(stock.risk.zhengli), setCnzz('查看公告', '点击查看退市整理期公告', '')">{{stock.risk.zhengli.title}}</a>
                <span class="External-date">{{stock.risk.zhengli.publishdate}}</span>
              </p>
              <p class="time" v-else>--</p>
            </li>
            <li>
              <p class="date">摘帽未满一年</p>
              <p class="time" v-if="stock.risk.zhaimao">
                <a class="info-Underline" @click="goNotice(stock.risk.zhaimao), setCnzz('查看公告', '点击查看摘帽未满一年公告', '')">{{stock.risk.zhaimao.title}}</a>
                <span class="External-date">{{stock.risk.zhaimao.publishdate}}</span>
              </p>
              <p class="time" v-else>--</p>
            </li>
            <li>
              <p class="date">恢复上市未满一年</p>
              <p class="time" v-if="stock.risk.huifu">
                <a class="info-Underline" @click="goNotice(stock.risk.huifu), setCnzz('查看公告', '点击查看恢复上市未满一年公告', '')">{{stock.risk.huifu.title}}</a>
                <span class="External-date">{{stock.risk.huifu.publishdate}}</span>
              </p>
              <p class="time" v-else>--</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 标的公司业绩 -->
      <div class="dhy-details-box">
        <h3 class="">标的公司业绩</h3>
      </div>
      <div class="pledge-list-box3">
        <div class="title">近五年营业收入</div>
        <ul v-for="(index, item) in yearlist" track-by="$index">
          <li class="active">{{ item }}</li>
          <li><p class="date">营业收入(元)</p><p class="time">{{ businessincome[index] | money }}</p></li>
          <li><p class="date">营业收入同比增长率(%)</p><p class="time">{{ yysrtbzzl[index] }}</p></li>
        </ul>
      </div>
      <div class="rate-chart-wrap">
        <div class="businesschart standard-chart" v-if="yearlist.length > 0" style="height:180px;width:100%;float:left;"></div>
      </div>

      <!-- 近五年归母净利润 -->
      <div class="pledge-list-box3">
        <div class="title">近五年归母净利润</div>
        <ul v-for="(index, item) in yearlist" track-by="$index">
          <li class="active">{{ item }}</li>
          <li><p class="date">归母净利润(元)</p><p class="time">{{ retainedprofitowner[index] | money }}</p></li>
          <li><p class="date">归母净利润同比增长率(%)</p><p class="time">{{ gmjlrtbzzl[index] }}</p></li>
        </ul>
      </div>
      <!-- 图 -->
      <div class="rate-chart-wrap">
        <div class="gmjlrchart standard-chart" v-if="yearlist.length > 0" style="height:180px;width:100%;float:left;"></div>
      </div>

      <!-- 最近一期归母净利润 -->
      <div class="pledge-list-box" v-if="lastDate.date">
        <ul>
          <li class="active">最近一期归母净利润</li>
          <li>
            <p class="date">最近报告期</p>
            <p class="time">{{lastDate.date}}</p>
          </li>
          <li>
            <p class="date">归母净利润(元)</p>
            <p class="time">{{lastDate.value | money}}</p>
          </li>
          <li>
            <p class="date">归母净利润同比增长率(%)</p>
            <p class="time">{{lastDate.ratio}}</p>
          </li>
        </ul>
      </div>

      <div class="pledge-list-box1" v-if="showcompany">
        <!-- 标的公司近三年监管及处罚信息 -->
        <ul>
          <li class="active">标的公司近三年监管及处罚信息</li>
          <li class="title">证监会</li>
          <li>
            <p class="date">行政处罚</p>
            <p class="time" v-if="companyNoticeInfo.xzcf.total > 0">
              <a class="info-Underline" @click.self="goNotice(companyNoticeInfo.xzcf.lists[0]), setCnzz('[Mobile]-大黄押', '点击查看行政处罚公告', '')">{{companyNoticeInfo.xzcf.lists[0].title}}</a>
              <span class="External-date">{{companyNoticeInfo.xzcf.lists[0].publishDate}}</span>
              <a class="more-right" style="cursor:pointer" v-if="companyNoticeInfo.xzcf.total > 1" @click.self="showlists(companyNoticeInfo.xzcf.lists), setCnzz('[Mobile]-大黄押', '点击查看更多', '')">更多&gt;</a>
            </p>
            <p class="time" v-else>--</p>
          </li>
          <li>
            <p class="date">立案调查</p>
            <p class="time" v-if="companyNoticeInfo.ladc.total > 0">
              <a class="info-Underline" @click.self="goNotice(companyNoticeInfo.ladc.lists[0]), setCnzz('[Mobile]-大黄押', '点击查看立案调查公告', '')">{{companyNoticeInfo.ladc.lists[0].title}}</a>
              <span class="External-date">{{companyNoticeInfo.ladc.lists[0].publishDate}}</span>
              <a class="more-right" style="cursor:pointer" v-if="companyNoticeInfo.ladc.total > 1" @click.self="showlists(companyNoticeInfo.ladc.lists), setCnzz('[Mobile]-大黄押', '点击查看更多', '')">更多&gt;</a>
            </p>
            <p class="time" v-else>--</p>
          </li>
          <li>
            <p class="date">监管措施</p>
            <p class="time" v-if="companyNoticeInfo.jgcszjh.total > 0">
              <a class="info-Underline" @click.self="goNotice(companyNoticeInfo.jgcszjh.lists[0]), setCnzz('[Mobile]-大黄押', '点击查看监管措施公告', '')">{{companyNoticeInfo.jgcszjh.lists[0].title}}</a>
              <span class="External-date">{{companyNoticeInfo.jgcszjh.lists[0].publishDate}}</span>
              <a class="more-right" style="cursor:pointer" v-if="companyNoticeInfo.jgcszjh.total > 1" @click.self="showlists(companyNoticeInfo.jgcszjh.lists), setCnzz('[Mobile]-大黄押', '点击查看更多', '')">更多&gt;</a>
            </p>
            <p class="time" v-else>--</p>
          </li>
          <li>
            <p class="date">市场禁入</p>
            <p class="time" v-if="companyNoticeInfo.scjr.total > 0">
              <a class="info-Underline" @click.self="goNotice(companyNoticeInfo.scjr.lists[0]), setCnzz('[Mobile]-大黄押', '点击查看市场禁入公告', '')">{{companyNoticeInfo.scjr.lists[0].title}}</a>
              <span class="External-date">{{companyNoticeInfo.srjc.lists[0].publishDate}}</span>
              <a class="more-right" style="cursor:pointer" v-if="companyNoticeInfo.scjr.total > 1" @click.self="showlists(companyNoticeInfo.scjr.lists), setCnzz('[Mobile]-大黄押', '点击查看更多', '')">更多&gt;</a>
            </p>
            <p class="time" v-else>--</p>
          </li>
          <li class="title">交易所</li>
          <li>
            <p class="date">监管问询</p>
            <p class="time" v-if="companyNoticeInfo.jgwx.total > 0">
              <a class="info-Underline" @click.self="goNotice(companyNoticeInfo.jgwx.lists[0]), setCnzz('[Mobile]-大黄押', '点击查看监管问询公告', '')">{{companyNoticeInfo.jgwx.lists[0].title}}</a>
              <span class="External-date">{{companyNoticeInfo.jgwx.lists[0].publishDate}}</span>
              <a class="more-right" style="cursor:pointer" v-if="companyNoticeInfo.jgwx.total > 1" @click.self="showlists(companyNoticeInfo.jgwx.lists), setCnzz('[Mobile]-大黄押', '点击查看更多', '')">更多&gt;</a>
            </p>
            <p class="time" v-else>--</p>
          </li>
          <li>
            <p class="date">监管措施</p>
            <p class="time" v-if="companyNoticeInfo.jgcs.total > 0">
              <a class="info-Underline" @click.self="goNotice(companyNoticeInfo.jgcs.lists[0]), setCnzz('[Mobile]-大黄押', '点击查看监管措施公告', '')">{{companyNoticeInfo.jgcs.lists[0].title}}</a>
              <span class="External-date">{{companyNoticeInfo.jgcs.lists[0].publishDate}}</span>
              <a class="more-right" style="cursor:pointer" v-if="companyNoticeInfo.jgcs.total > 1" @click.self="showlists(companyNoticeInfo.jgcs.lists), setCnzz('[Mobile]-大黄押', '点击查看更多', '')">更多&gt;</a>
            </p>
            <p class="time" v-else>--</p>
          </li>
        </ul>
        <!-- 标的证券是否存在司法冻结 -->
        <ul>
          <li class="active">标的证券是否存在司法冻结</li>
          <li>
            <p class="time" v-if="stock.risk.dongjie">
              <a class="info-Underline" @click="goNotice(stock.risk.dongjie), setCnzz('[Mobile]-大黄押', '点击查看司法冻结公告', '')">{{stock.risk.dongjie.title}}</a>
              <span class="External-date">{{stock.risk.dongjie.publishdate}}</span>
            </p>
            <p class="time" v-else>--</p>
          </li>
        </ul>
      </div>
    </div>

    <!-- 重要公告 -->
    <div class="search-result-box important-goga" v-if="relationNotice.lists.length>0">
      <h3 class="">重要公告</h3>

      <div class="search-result-list" v-for="notice in relationNotice.lists">
        <p class="head">
          <span class="{{ fileIcon(notice.fileext) }}"></span>
          <a href="javascript:;"  @click="relationNoticeDetail(notice)">{{ notice.title }}</a>
        </p>
        <p class="Subtitle">
          <!-- <span class="fl">证券代码：2520008</span> -->
          <span class="fr">{{ notice.publishDate }}</span>
        </p>
      </div>

      <!--加载动画-->
      <div class="more" v-show="!loading && relationNotice.page < relationNotice.totalPage && relationNotice.total !== 0" style="margin-top: -8px;">
        <i class="pull_icon loading"></i>
        <span style="font-size: 15px;">加载中...</span>
      </div>
    </div>

    <!--微信绑定弹框-->
    <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" :style="{'display': tipGoBind ? 'block' : 'none'}">
      <div class="binding-content">
        <a class="binding-logo"></a>
        <div class="binding-text">
          立即绑定IBDATA账号<br/>成为金融分析高手
        </div>
        <div class="binding-bot">
          <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
          <a class="binding-btn" @click="goBindPage">立即绑定</a>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade in" :style="{'display': tipGoBind ? 'block' : 'none'}"></div>
    <!-- / 微信绑定弹框-->
  </div>

  <!-- 更多 -->
  <div class="wrapper more-wrapper" v-show="viewMore.show">
    <div class="company-details-title">
      <span class="cancle-btn" @click="viewMore.show=false, viewMore.lists=[]"></span>
      <!-- <span class="menu-options blue">重要公告</span> -->
    </div>
    <div class="search-result-box important-more">
      <div class="search-result-list" v-for="item in viewMore.lists">
        <p class="head">
          <!-- <span class="dov-icon"></span> -->
          <a href="javascript:;" @click="goNotice(item), setCnzz('[mobile]-大黄押', '点击查看更多列表中的公告', '')">{{ item.title }}</a>
        </p>
        <p class="Subtitle">
          <!-- <span class="fl">证券代码：2520008</span> -->
          <span class="fr">{{ item.publishDate }}</span>
        </p>
      </div>
    </div>
  </div>
  <!-- /更多 -->
</template>

<script>
  import { apiUrl, alert } from '../../helper'
  import searchMix from '../../common/SearchMix'
  import userMix from '../../common/userMix'
  import wxshareMix from '../../common/wxshareMix'
  import echarts from 'echarts'
  import echartMix from '../../common/echartMix'
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  import $ from 'jquery'

  export default {
    name: 'StockPledgeView',
    mixins: [userMix, wxshareMix, searchMix, echartMix],
    data () {
      return {
        loading: false,
        underlyingSecur: null,    // 标的证券
        intoPerson: '',           // 融入方
        company: null,  // 公司信息
        //************************************************************
        pledgeePerson: '',        //质权人
        pledge: null,   // 质押信息
        pledgor: null,    //融入方
        stock: null,      // 标的证券基本信息
        yearlist: [],
        businessincome: [],       //营收数据
        yysrtbzzl: [],            // 营业收入同比增长率数据
        retainedprofitowner: [],    // 归母净利润
        gmjlrtbzzl: [],            // 归母净利润同比增长率数据
        companyNoticeInfo: {},      // 标的公司监管信息
        pledgorNoticeInfo: {},      // 融入方监管信息
        showcompany: false,
        showpledgor: false,
        morelists: [],
        publicunit: ['元', '%'],
        plateMap: {'SZCYB': '深市创业板', 'SZZB': '深市主板', 'SZZXB': '深市中小板', 'SHZB': '上证主板'},
        lastDate: {'date': null, 'value': null, 'ratio': null},
        loading: false,
        suggestion: [],
        oldsuggestValue: '',
        history_pledge: [],
        history_lifted: [],
        history_extension: [],
        //质押表排序： 0默认、1升序、2降序、3质权人降序
        historySort: {
          //质押
          pledge: {
            st: 0, //start time
            et: 0, //end time
            zqr: 0,
          },
          //解除质押
          lifted: {
            st: 0,
            et: 0,
            zqr: 0,
          },
          //质押展期
          extension: {
            st: 0,
            et: 0,
            zqr: 0,
          },
        },
        //echart 公司全场质押率
        rate_company: {
          dataX: [],
          dataY: []
        },
        //echart 深交所平均质押率
        rate_szse: {
          dataX: [],
          dataY: [],
          dataY2: [],
          legend: [],
        },
        //echart 上交所平均质押率
        rate_shse: {
          dataX: [],
          dataY: [],
          dataY2: [],
          legend: [],
        },
        curRateChart: '', //当前处于显示状态的平均质押图
        mergePledge: [],  //合并质押表数据
        mergePledgeToFiler: [], //合并质押表数据 用于筛选
        // mergePledge_tab2: 1,    //1表格  2图谱
        relationsData: [],
        mergePledge_date_typ: 'ALL',
        //合并质押排序
        // mergeSort: {
        //   st: null, //按质押开始日期
        //   et: null, //按质押结束日期
        //   zqr: null, //按债权人
        //   gdmc: null,
        //   jczy: null,
        //   pledge: [],      //其中质押性质为"质押"的
        //   extension: []    //其中质押性质为"质押延期"的
        // },
        originDataByZQR: [], //质权人排序前的数据序列
        originDataByGDMC: [], //质权人排序前的数据序列
        pledge_viewall: false,
        showMergePledgeNum: 5, //显示的历史信息条数
        pledge_type: 'ALL',
        pledgee_type: 'ALL',
        intoPerson_type: 'ALL',
        pledgeTypeList: {
          'ALL': '全  部',
          'dqrrf': '当前融入方信息',
          'zyqn': '质押期内信息',
        },
        pledgeInfoDropdown: false,
        date_typ: 'ALL',
        pledgee_date_typ: 'ALL',
        intoPerson_date_typ: 'ALL',
        dateTypList: {
          'ALL': '全 部',
          'onemonth': '一个月',
          'threemonth': '三个月',
          'halfyear': '半年',
          'oneyear': '一年',
          'twoyear': '两年',
          'threeyear': '三年',
          'fiveyear': '五年',
          'tenyear': '十年',
        },
        showDateDropdown: false,
        pageInfo: {},
        page: 1,
        perPage: 5,
        total: 0,
        relationnotice: [],  //重要公告
        tab: 1,  //1初步尽调信息  2融资信息  3质权人  4融入方
        tab1: '', //0列表页 1融资信息详情  2编辑
        tooltip_pledges: [],
        showTooltipDetail: false,
        financing: {  //融资信息
          list: [],   //列表
          page: 1,
          perPage: 5,
          total: 0,
          edit: {  //编辑or添加
            id: '',
            company_shortname: '',    //证券简称
            companycode: '',          //证券代码
            name_of_shareholder: '',  //融资人名称
            timelimit: '',            //过期时间
            timelimit_unit: '月',     //过期时间，缺省是月
            nature: '流通',           //股份性质，缺省是流通
            pledgee_nums: '',         //质押股数
            restriction_end_date: '', //限售解禁期
            pledgee_ratio: '',        //质押率
            financing_amount: '',     //融资金额
            use: '',                  //资金用途
            repayment_source: '',     //还款来源
            status: '',               //0 新增 1 已完成 9 删除
            stockprice: '',           //股价
          },
        },
        sharePriceDropdown: '',
        dropdown_menu_status: false,
        dropdown_menu_timelimit: false,
        dropdown_menu_list_status: false,
        sharelink: '',
        curShareId: '',
        qrcodeBoxID: '',
        qrcodeID: '',
        ts: '',
        suggestDropdownMenu: 0, //0都不显示 1证券简称 2证券代码
        fullscreen: false,
        showUseSuggestionMenu: false,
        // ==================================================================
        cumulative_pledge: [],  //累计质押
        cumPledge_page: 1,
        cumPledge_perPage: 5,
        cumPledge_total: 0,
        cumPledge_totalPage: 0,
        cumpledge_postData: {},
        cumPledge_echart: {},
        // ========================= 重要公告 ======================
        relationNotice: {
          lists: [],
          page: 1,
          perPage: 5,
          total: 0,
          pageTotal: 0,
          companycode: '',
          pageInfo: {}
        },
        // ======================== 历史质押信息 滑动分页 ===========
        pledgeePaging: {
          currentpage: 1,
          totalPage: 0,
          allpage: [],
        },
        tipGoBind: false,
        viewMore: {
          show: false,
          lists: [],
        },
      }
    },
    ready () {
      $('.cheight').css('min-height', $(window).height() - 200);
      $('.more-wrapper').css('height', $(window).height());
      $('.more-wrapper .search-result-box').css('height', $(window).height()-40);

      // 绑定滑动分页
      this.$nextTick(function() {
        // setTimeout(function() {
        //   var mySwiper = new Swiper('.swiper-container', {
        //     pagination: {
        //       el: '.swiper-pagination',
        //       type: 'fraction',
        //     },
        //     // navigation: {
        //     //   nextEl: '.swiper-button-next',
        //     //   prevEl: '.swiper-button-prev',
        //     // },
        //     // autoplay:true,
        //     // loop:true
        //   });
        // }, 8000);

        let that = this;
        let num = 0;
        let timer = setInterval(function() {
          num += 3000;
          if (that.mergePledge.length > 0 && num > 60000) {
            // console.log(that.cumulative_pledge);
            // console.log(that.mergePledge);
            var mySwiper = new Swiper('.swiper-container', {
              pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
              },
              // navigation: {
              //   nextEl: '.swiper-button-next',
              //   prevEl: '.swiper-button-prev',
              // },
              // autoplay:true,
              // loop:true
            });

            clearInterval(timer);
          } else if(that.cumulative_pledge.length > 0 && num > 60000) {
            // console.log(that.cumulative_pledge);
            // console.log(that.mergePledge);
            var mySwiper = new Swiper('.swiper-container', {
              pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
              },
              // navigation: {
              //   nextEl: '.swiper-button-next',
              //   prevEl: '.swiper-button-prev',
              // },
              // autoplay:true,
              // loop:true
            });

            clearInterval(timer);
          }
        }, 3000);
      });
    },
    created () {
      $('meta')[2].content = 'width=device-width, initial-scale=1';
    },
    route: {
      data ({ to }) {
        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            this.getProfile(to.query.share)
          }
        }
        if (this.currentuser) {
          this.params.tab = to.query.tab
          this.params.shortname = to.query.shortname;  //标的证券
          this.params.pledgor = to.query.pledgor;      //融入方
          this.params.uidUrl = to.query.uid
          this.params.share = to.query.share
          this.params.plat = to.query.plat
          this.params.ts = to.query.ts
          this.params.sid = to.query.sid
          this.params.ruid = to.query.ruid

          let descs = window.location.href.split('&');
          for (var i=0,len=descs.length; i<len; i++) {
            let str = descs[i];
            if (str.indexOf('desc=') == 0) {
              this.params.desc = decodeURIComponent(str.split('=')[1])
              break;
            }
          }

          this.routeStart();

          // 绑定滚动加载事件
          jQuery(window).unbind()
          $(window).unbind()
          let that = this
          $(window).scroll(function() {

            let scrollTop = $(this).scrollTop()       // 滚动条距页顶的距离
            let scrollHeight = $(document).height()   // 浏览器时下窗口文档的高度
            let windowHeight = $(this).height()       // 窗口高

            if (that.relationNotice.totalPage && that.relationNotice.companycode != '') {
              // 滚动到底部
              if (scrollTop + windowHeight >= scrollHeight) {
                let next_page = parseInt(that.relationNotice.page) + 1
                if (that.relationNotice.page < that.relationNotice.totalPage) {  // 分页页码<总页数
                  that.relationNotice.page = next_page;
                  that.getRelationNotice(that.relationNotice.companycode);
                }
              }
            }
          });

          // ======================================= 微信分享
          let share_title = '[大黄押] ' + this.params.desc;
          let share_desc = this.getResultShareDesc();
          this.changeMetaTitle(share_title);
          this.getwxsign();    // 微信签名
          this.shareDhyCbjd(share_title, share_desc); //分享大黄押初步尽调
        }
      }
    },
    filters: {
      plate: function (value) {
        return this.plateMap[value]
      },
      nullVal: function (value) {
        if (!value) {
          return '--'
        } else if (value == 'zzzz') {
          return '--'
        }else {
          return value
        }
      },
      formartPledgeType: function(value) {
        for (var key in this.pledgeTypeList) {
          if (key == value) {
            return this.pledgeTypeList[key];
          }
        }
      },
      formatDateTyp: function(param) {
        for (var code in this.dateTypList) {
          if (code == param) {
            return this.dateTypList[code];
          }
        }
      },
      formatTime(time) {
        if (!time) { return }
        if (time.indexOf('T') > 0) {
          return time.split('T')[0];
        } else {
          return time;
        }
      },
      formatNumber(num) {
        num = num / 10000;
        if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(num)) {
            return num;
        }
        var a = RegExp.$1, b = RegExp.$2, c = RegExp.$3;
        var re = new RegExp("(\\d)(\\d{3})(,|$)");
        while (re.test(b))   b = b.replace(re, "$1,$2$3");
        return a + "" + b + "" + c;
      },
    },
    methods: {
      routeStart: function() {
        this.search();      //搜索
        this.getMergePledge();       //历史质押信息
        if (this.params.pledgor && this.params.pledgor!='') {
          this.getCumulativePledge();  //累计质押数据
        }
        this.pledgeRate();  //质押比率
        this.getSupervisionInfo();  //标的公司信息
      },
      /**
       * 初步尽调 搜索
       */
      search: function () {
        this.pledgeInfoDropdown = false;   //筛选下拉框
        this.pledge_type = 'ALL';          //筛选类型
        this.relationnotice = [];          //重要公告
        this.total = 0;
        this.page = 1;

        this.loading = true
        this.history_extension = []
        this.history_lifted = []
        this.history_pledge = []
        this.company = null //公司信息
        this.pledge = null  //质押信息
        this.pledgor = null //融入方
        this.stock = null   //标的证券基本信息
        this.lastDate = {'date': null, 'value': null, 'ratio': null}  //最近一期归母净利润
        this.businessincome = []
        this.yysrtbzzl = []
        this.retainedprofitowner = []
        this.gmjlrtbzzl = []
        this.yearlist = []
        this.showcompany = false
        this.showpledgor = false

        let query = {};
        query.shortname = this.params.shortname;  //标的证券
        query.pledgor = this.params.pledgor;      //融入方
        query.sid = this.params.sid;
        query.uid = parseInt(this.params.uidUrl)
        query.share = this.params.share
        query.plat = this.params.plat
        query.ruid = this.params.ruid

        console.log(query);
        $.ajax({
          url: apiUrl('/V1.0.0/pledge/baseinfo'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {
          this.loading = false
          if (response.status == 0) {

            // this.getCumulativePledge();  //累计质押数据
            // this.getMergePledge();       //历史质押信息
            // this.pledgeRate();           //质押率
            // this.getSupervisionInfo()

            // if (this.intoPerson != 0) {
            if (this.params.pledgor && this.params.pledgor!='') {
              this.getPledgorInfo()
            }
            this.relationNotice.companycode = response.data.company.code;
            this.getRelationNotice(response.data.company.code);  //重要公告
            this.company = response.data.company
            this.pledge = response.data.pledge
            this.pledgor = response.data.pledgor
            this.stock = response.data.stock

            // stock不为空
            if (Object.keys(this.stock.finance).length > 0) {
              let yearlist = []
              let allyear = []
              for (let year in this.stock.finance) {
                if (year.indexOf('-12-') > 0) {
                  yearlist.push(year)
                }
                allyear.push(year)
              }
              allyear.sort(function (a, b) {return parseInt(b.replace(/-/g, '')) - parseInt(a.replace(/-/g, ''))})

              this.lastDate.date = allyear[0]
              this.lastDate.value = this.stock.finance[allyear[0]].retainedprofitowner
              this.lastDate.ratio = this.stock.finance[allyear[0]].gmjlrtbzzl || '--'
              yearlist.sort(function (a, b) {return parseInt(b.replace(/-/g, '')) - parseInt(a.replace(/-/g, ''))})

              this.yearlist = yearlist.slice(0, 5)  //近五年营业收入 - 时间
              this.businessincome = [];             //营业收入
              this.yysrtbzzl = [];                  //营业收入同比增长率
              this.retainedprofitowner = [];        //归母净利润
              this.gmjlrtbzzl = [];                 //归母净利润同比增长率

              var chartBusiness = [[' ', '营业收入', '营业收入同比增长率']];
              var chartGMJLR = [[' ', '归母净利润', '归母净利润同比增长率']];
              for (let y of this.yearlist) {
                //营业收入
                this.businessincome.push(this.stock.finance[y].businessincome ? this.stock.finance[y].businessincome : '--');
                //营业收入同比增长率
                this.yysrtbzzl.push(this.stock.finance[y].yysrtbzzl ? this.stock.finance[y].yysrtbzzl : '--');
                //归母净利润
                this.retainedprofitowner.push(this.stock.finance[y].retainedprofitowner ? this.stock.finance[y].retainedprofitowner : '--');
                //归母净利润同比增长率
                this.gmjlrtbzzl.push(this.stock.finance[y].gmjlrtbzzl ? this.stock.finance[y].gmjlrtbzzl : '--')
              }

              // console.log(this.gmjlrtbzzl)
              // console.log(this.yysrtbzzl)
              for (let i = this.yearlist.length-1; i >= 0; i--) {
                let tmp = []
                tmp.push(this.yearlist[i])
                tmp.push(this.stock.finance[this.yearlist[i]].businessincome ? this.stock.finance[this.yearlist[i]].businessincome: 0)
                tmp.push(this.stock.finance[this.yearlist[i]].yysrtbzzl ? this.stock.finance[this.yearlist[i]].yysrtbzzl: 0)
                chartBusiness.push(tmp)
                let gm = []
                gm.push(this.yearlist[i])
                gm.push(this.stock.finance[this.yearlist[i]].retainedprofitowner ? this.stock.finance[this.yearlist[i]].retainedprofitowner : 0)
                gm.push(this.stock.finance[this.yearlist[i]].gmjlrtbzzl ? this.stock.finance[this.yearlist[i]].gmjlrtbzzl : 0)
                chartGMJLR.push(gm)
              }

              this.$nextTick(function() {
                // let echart = document.querySelector('.businesschart');
                // let echart2 = document.querySelector('.gmjlrchart');

                let that = this;
                let echart = '';
                let echart2 = '';
                let max_time = 0;
                let timer = setInterval(function() {
                  max_time += 1000;
                  echart = document.querySelector('.businesschart');
                  echart2 = document.querySelector('.gmjlrchart');

                  console.log(max_time);
                  if (max_time > 6000) {
                    clearInterval(timer);
                    return false;
                  }
                  if (echart && echart2) {
                    console.log('clear timer')
                    clearInterval(timer);
                    that.echartBar(chartBusiness, that.publicunit, 'business')
                    that.echartBar(chartGMJLR, that.publicunit, 'gmjlr')
                  }
                }, 1000);
              });
              // let chartBusiness = [[' ', '营业收入', '营业收入同比增长率']]
            }
          } else {
            alert(response.description)
          }
        }).fail((response) => {
          this.loading = false
          alert('请求失败')
        })
      },
      //累计质押
      getCumulativePledge: function() {
        let query = {};
        query.shortname = this.params.shortname;  //标的证券
        query.pledgor = this.params.pledgor;      //融入方
        query.uid = parseInt(this.params.uidUrl)
        query.ruid = this.params.ruid
        query.share = this.params.share
        query.plat = this.params.plat
        query.sid = this.params.sid;

        // this.loading = true;
        $.ajax({
          url: apiUrl('/V1.0.0/pledge/cumulative'),
          type: 'POST',
          dataType: 'json',
          data: JSON.stringify(query)
        })
        .done((response) => {
          // this.loading = false;
          if (response.status == 0) {
            this.cumulative_pledge = response.data;
            this.cumPledge_total = response.data.length;
            this.cumPledge_totalPage = Math.ceil(response.data.length / this.cumPledge_perPage);

              // 全场
          if (response.data && response.data.length>0) {
            let data = response.data
            let dataX = [];  // 日期
            let dataY = {    // 质押数
              type: 'line',
              data: []
            };

            if (data.length > 1) {
            //补全日期 数据
              let allDate = this.getAllDay(data[data.length-1]['publishdate'], data[0]['publishdate']);
              allDate.unshift(data[data.length-1]['publishdate']);
              console.log(allDate);
              let newData = [];
              for (let i=0, len=allDate.length; i<len; i++) {
                let isHased = false;
                for (let j=0, len=data.length; j<len; j++) {
                  if (allDate[i] == data[j].publishdate) {
                    newData.push(data[j]);
                    isHased = true;
                    break;
                  }
                }
                if (!isHased) {
                  newData.push({
                    publishdate: allDate[i],
                    cumulative_pledge_proportion_of_total_capital: null
                  });
                }
              }
              data = newData;
            }

            let len = data.length;
            // for (var i=len-1; i>=0; i--) {
            for (var i=0, len=data.length; i<len; i++) {
              dataX.push( data[i]['publishdate'] );
              // dataY.data.push( data[i]['cumulative_pledge_proportion_of_total_capital'] );
              dataY.data.push( data[i]['cumulative_pledge_proportion_of_shares_held'] );
            }
            this.cumPledge_echart.dataX = dataX
            this.cumPledge_echart.dataY = dataY
          } else if (response.data && response.data.length==0) {
            this.cumPledge_echart.dataX = []
            this.cumPledge_echart.dataY = []
          }

          console.log(this.cumPledge_echart)
          // 累计质押图
          this.$nextTick(function() {
            this.echartLineNumber(this.cumPledge_echart, '', '', 'cumPledge', '.analyze-chart-box3', '.rate-chart3');
            // this.echartLineNumber(this.cumPledge_echart, '累计质押', '', 'cumPledge', '.analyze-chart-box3', '.rate-chart3');
          });
          }
        })
        .fail((response) => {
          // this.loading = false;
          alert(response.description);
        });
      },

      //获取合并质押表
      getMergePledge() {
        let query = {};
        query.shortname = this.params.shortname;  //标的证券
        query.pledgor = this.params.pledgor;      //融入方
        query.sid = this.params.sid;
        query.uid = parseInt(this.params.uidUrl)
        query.share = this.params.share
        query.plat = this.params.plat
        query.ruid = this.params.ruid

        // this.loading = true;
        $.ajax({
          url: apiUrl('/V1.0.0/pledge/pledgeinfo'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {
          // this.loading = false;
          if (response.status === 0) {
            this.mergePledge = response.data;
            this.mergePledgeToFiler = response.data;
            this.pledgeePaging.allpage = response.data;
            this.pledgeePaging.totalPage = response.data.length;

            let _data = response.data
            if (_data.length > 0) {
              // console.log('>>>>>>>>> 0');
              //存在“融入方”，初始时 历史质押表中显示融入方的信息
              if (this.params.pledgor && this.params.pledgor!='') {
                // console.log('>>>>>>>>>> 1');
                // if (item.name_of_shareholder == this.params.pledgor) {
                  this.filterPledgeInfo('dqrrf');
                // }
              } else {
                // console.log('>>>>>>>>>>>>>>>>>> 3');
                this.mergePledge = [];
                this.mergePledgeToFiler = [];
              }
            }

            // let pledge = [];     //质押
            // let extension = [];  //质押延期

            // for (let item of _data) {
            //   if (item.src == 'extension') {
            //     extension.push( item );
            //   } else {
            //     pledge.push( item );
            //   }
            // }

            // this.mergeSort.pledge = pledge;
            // this.mergeSort.extension = extension;
          } else {
            alert(response.description)
          }
        }).fail((response) => {
          // this.loading = false;
          alert('请求失败')
        })
      },
      //筛选 初步尽调-历史质押信息表
      filterPledgeInfo(type) {
        // console.log(type);

        let arr = [];
        //当前融入方信息
        //融入方基本信息中股东名称不为空
        if (type == 'dqrrf') {
          let rrfname = '';
          if (this.pledgor && this.pledgor.holder && this.pledgor.holder.name) {
            // console.log('>>>>>>>>>>>>>>>>>> 5')
            // console.log('this.pledgor.holder.name');
            for (let item of this.mergePledgeToFiler) {
              rrfname = $.trim(item.name_of_shareholder);
              if (rrfname == this.pledgor.holder.name) {
                arr.push(item);
              }
            }
          } else if (this.params.pledgor && this.params.pledgor.length>0) {
            // console.log('>>>>>>>>>>>>>>> 6');
            // console.log(this.params.pledgor);

            let intoPerson = $.trim( this.params.pledgor );
            for (let item of this.mergePledgeToFiler) {
              rrfname = $.trim(item.name_of_shareholder);
              if (rrfname == intoPerson) {
                arr.push(item);
              }
            }
          }
          this.mergePledge = arr;
        }
        //质押期内信息
        // if (type == 'zyqn') {
        //   for (let item of this.mergePledgeToFiler) {
        //     //存在解除质押日期
        //     if (item.release_pledge_date && this.moreNowday(item.release_pledge_date)) {
        //       arr.push(item);
        //     }
        //     //不存在解除质押日期
        //     if (!item.release_pledge_date && item.pledge_due_date) {
        //       if (this.moreNowday(release_pledge_date)) {
        //         arr.push(item);
        //       }
        //     }
        //   }

        //   this.mergePledge = arr;
        // }
        // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')
        // console.log(this.mergePledgeToFiler);
        // console.log(this.mergePledge);
        // console.log('历史质押信息表长度：' + this.mergePledge.length)


        // let _data = this.mergePledge;
        // let pledge = [];
        // let extension = [];
        // if (_data.length == 0) {
        //   this.mergeSort.pledge = [];
        //   this.mergeSort.extension = [];
        //   return;
        // }

        // for (let item of _data) {
        //   if (item.src == 'extension') {
        //     extension.push( item );
        //   } else {
        //     pledge.push( item );
        //   }
        // }
        // this.mergeSort.pledge = pledge;
        // this.mergeSort.extension = extension;
      },
      //质押比率
      pledgeRate() {
        let query = {};
        query.shortname = this.params.shortname;  //标的证券
        query.pledgor = this.params.pledgor;      //融入方
        query.sid = this.params.sid;
        query.uid = parseInt(this.params.uidUrl)
        query.share = this.params.share
        query.plat = this.params.plat
        query.ruid = this.params.ruid

        // this.loading = true;
        $.ajax({
          url: apiUrl('/V1.0.0/pledge/pledgerate'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {
          // this.loading = false;
          if (response.status === 0) {
            if (response.data.company && response.data.company.length>0) {
              let company = response.data.company
              let dataX = [];  // 日期
              let dataY = {    // 质押率
                type: 'line',
                data: []
              };

              for (var i=0,len=company.length; i<len; i++) {
                dataX.push( company[i]['date'] );
                dataY.data.push( company[i]['pledge_ratio'] );
              }
              this.rate_company.dataX = dataX
              this.rate_company.dataY = dataY

            } else if (response.data.company && response.data.company.length==0) {
              this.rate_company.dataX = []
              this.rate_company.dataY = []
            }
            if (response.data.szse && response.data.szse.length>0) {
              let dataX = [];   // 日期
              let dataY = {
                name:'限售股平均质押率',
                type:'line',
                // stack: '总量',
                data: []
              };
              let dataY2 = {
                name:'非限售股平均质押率',
                type:'line',
                // stack: '总量',
                data: []
              };
              let legend = ['限售股平均质押率', '非限售股平均质押率']

              for (var i=0,len=response.data.szse.length; i<len; i++) {
                dataX.push( response.data.szse[i]['date'] );
                dataY.data.push( response.data.szse[i]['limited_shares_conditional_pledging_rate'] );
                dataY2.data.push( response.data.szse[i]['unlimited_shares_pledged_rate'] );
              }
              this.rate_szse.dataX = dataX
              this.rate_szse.dataY = dataY
              this.rate_szse.dataY2 = dataY2
              this.rate_szse.legend = legend
            } else if (response.data.szse && response.data.szse.length==0) {
              this.rate_szse.dataX = [];
              this.rate_szse.dataY = [];
              this.rate_szse.dataY2 = [];
              this.rate_szse.legend = [];
            }

            if (response.data.shse && response.data.shse.length>0) {
              let dataX = [];   // 日期
              let dataY = {
                name:'限售股平均质押率',
                type:'line',
                // stack: '总量',
                data: []
              };
              let dataY2 = {
                name:'非限售股平均质押率',
                type:'line',
                // stack: '总量',
                data: []
              };
              let legend = ['限售股平均质押率', '非限售股平均质押率']

              for (var i=0,len=response.data.shse.length; i<len; i++) {
                dataX.push( response.data.shse[i]['date'] );
                dataY.data.push( response.data.shse[i]['limited_shares_conditional_pledging_rate'] );
                dataY2.data.push( response.data.shse[i]['unlimited_shares_pledged_rate'] );
              }
              this.rate_shse.dataX = dataX
              this.rate_shse.dataY = dataY
              this.rate_shse.dataY2 = dataY2
              this.rate_shse.legend = legend
            } else if (response.data.shse && response.data.shse.length==0) {
              this.rate_shse.dataX = [];
              this.rate_shse.dataY = [];
              this.rate_shse.dataY2 = [];
              this.rate_shse.legend = [];
            }

            this.$nextTick(function() {
              this.echartLine(this.rate_company, '全场质押比例', '', 'company', '.analyze-chart-box', '#rate-chart');
              if (response.data.szse && response.data.szse.length>0) {
                this.echartLine(this.rate_szse, '深交所平均质押率', this.rate_szse.legend, 'szse', '.analyze-chart-box2', '#rate-chart2');
              }
              if (response.data.shse && response.data.shse.length>0) {
                this.echartLine(this.rate_shse, '上交所平均质押率', this.rate_shse.legend, 'shse', '.analyze-chart-box2', '#rate-chart2');
              }
            });
          } else {
            alert(response.description)
          }
        }).fail((response) => {
          // this.loading = false;
          alert('请求失败')
        })
      },
      // 标的公司监管信息
      getSupervisionInfo: function () {
        this.companyNoticeInfo = {}
        this.showcompany = false

        let query = {};
        query.shortname = this.params.shortname;  //标的证券
        // query.pledgor = this.params.pledgor;      //融入方
        query.sid = this.params.sid;
        query.uid = parseInt(this.params.uidUrl);
        query.share = this.params.share;
        query.plat = this.params.plat;
        query.ruid = this.params.ruid;

        // this.loading = true;
        $.ajax({
          url: apiUrl('/V1.0.0/pledge/companynoticeinfo'),
          method: 'post',
          dataType: 'json',
          // data: JSON.stringify({'shortname': this.params.shortname})
          data: JSON.stringify(query)
        }).done((response) => {
          // this.loading = false;
          if (response.status == 0) {
            this.companyNoticeInfo = response.data
            this.showcompany = true
          } else {
            alert(response.description)
          }
        }).fail((response) => {
          // this.loading = false;
          alert('请求失败')
        })
      },
      //重要公告
      getRelationNotice: function(companycode) {
        console.log(this.relationNotice.companycode)
        this.relationNotice.pageInfo.page = this.relationNotice.page;
        this.relationNotice.pageInfo.perPage = this.relationNotice.perPage;
        if (companycode) {
          this.relationNotice.pageInfo.companycode = companycode;
        } else {
          this.relationNotice.pageInfo.companycode = this.relationNotice.companycode;
        }

        // this.loading = true;
        $.ajax({
          url: apiUrl('/V1.0.0/pledge/relationnotice'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(this.relationNotice.pageInfo)
        }).done((response) => {
          // this.loading = false;
          if (response.status == 0) {
            this.relationNotice.total = response.data.total;
            this.relationNotice.totalPage = Math.ceil( this.relationNotice.total / this.relationNotice.perPage);
            this.relationNotice.lists = this.relationNotice.lists.concat(response.data.lists);
          }
          else {
            alert(response.description)
          }
        }).fail((response) => {
          // this.loading = false;
          alert('请求失败')
        })
      },
      // 融入方监管信息
      getPledgorInfo: function () {
        this.pledgorNoticeInfo = {}
        this.showpledgor = false

        let query = {};
        query.shortname = this.params.shortname;  //标的证券
        query.pledgor = this.params.pledgor;      //融入方
        query.uid = parseInt(this.params.uidUrl)
        query.ruid = this.params.ruid
        query.share = this.params.share
        query.plat = this.params.plat
        query.sid = this.params.sid;

        // this.loading = true;
        $.ajax({
          url: apiUrl('/V1.0.0/pledge/pledgornoticeinfo'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {
          // this.loading = false;
          if (response.status == 0) {
            this.pledgorNoticeInfo = response.data;
            this.showpledgor = true;
          } else {
            alert(response.description);
          }
        }).fail((response) => {
          // this.loading = false;
          alert('请求失败');
        })
      },
      // 重要公告原文
      relationNoticeDetail(h) {
        // 未绑定微信，提示去绑定
        if (this.currentRegtyp === 4) {
          this.tipGoBind = true;
          return;
        }

        this.setCnzz('[Mobile]-大黄押', '查看重要公告原文', '');
        let url = window.location.origin + '/#!/notice-detail/' + h.id + '?stype=1&tcode=&pdate=' + h.publishDate + '&idxname=&uid=' + this.uid +'&share=weixin&plat=web&ts=' + this.params.ts + '&ext=&sid=' + this.params.sid;

        window.location.href = url;
      },
      // 查看公告
      goNotice: function (item) {
        // 未绑定微信，提示去绑定
        if (this.currentRegtyp === 4) {
          this.tipGoBind = true;
          return;
        }

        let url = this.viewUrl(item);
        window.location.href = url;
      },
      viewUrl: function (item) {
        if (item.id) {
          return window.location.origin + '/#!/notice-detail/' + item.id + '?stype=1&pdate=' + item.publishDate + '&tcode=&idxname=&share=weixin&plat=web&ext=' + '&uid=' + this.uid + '&ruid=' + this.params.ruid + '&ts=' + this.params.ts + '&sid=' + this.params.sid;
        } else {
          return window.location.origin + '/#!/notice-detail/' + item.md5 + '?stype=1&pdate=' + item.publishdate + '&tcode=&idxname=&share=weixin&plat=web&ext=' + '&uid=' + this.uid + '&ruid=' + this.params.ruid + '&ts=' + this.params.ts + '&sid=' + this.params.sid;;
        }
      },
      // 查看融入放最新质押信息-详情
      viewStockTitle (item, tcode) {
        let _tcode = tcode + '-0'
        if (item.id) {
          let url = window.location.origin + '#!/notice-detail/' + item.id + '?stype=1&pdate=' + item.publishdate + '&tcode=' + '&ccode=' + _tcode;

          window.location.href = url;
        }
      },
      //查看表格全部内容
      viewStockTable (item, tcode, offset) {
        let _offset = parseInt(offset) + 1
        let _tcode = tcode + '-' + _offset.toString()
        if (item.id) {
          let url = window.location.origin + '/#!/notice-detail/' + item.id + '?stype=1&pdate=' + item.publishDate + '&tcode=' + _tcode;

          window.location.href = url;
        }
      },
      // 查看更多
      showlists: function (item) {
        // this.morelists = item
        console.log(item);
        this.viewMore.show = true;
        this.viewMore.lists = item;
        console.log(this.viewMore)
      },

      // *******************************************************
      //获取当前时间
      getNowTime () {
        var myDate = new Date(),
          year = myDate.getFullYear(),
          month = myDate.getMonth() + 1,
          day = myDate.getDate();

        if (month < 10) {
          month = '0' + month.toString();
        }

        if (day < 10) {
          day = '0' + day.toString();
        }
        return year + '-' + month + '-' + day + 'T00:00:00'
      },
      //是否大于当前日期
      moreNowday(time) {
        var now = this.getNowTime().split('T')[0];
        now = now.split('-')[0] +  now.split('-')[1] +  now.split('-')[2];
        if (time.indexOf('T') > 0) {
          time = time.split('T')[0]
        }
        time = time.split('-')[0] +  time.split('-')[1] + time.split('-')[2];
        if (time > now) {
          return true;
        } else {
          return false;
        }
      },
      hidePledgeDropdown(e) {
        let _con = $('.dhy-choice-list')
        // 判断点击是否发生在空白区域
        if (!_con.is(e.target) && _con.has(e.target).length === 0) {
          this.pledgeInfoDropdown = false;
        }
      },
      hideDateDropmenu(e) {
        let _con = $('.dhy-filter-date-list')
        // 判断点击是否发生在空白区域
        if (!_con.is(e.target) && _con.has(e.target).length === 0) {
          this.showDateDropdown = false;
        }
      },
      hideModelDateDropmenu(e) {
        let _con = $('.abs-Regulatory-Date')
        // 判断点击是否发生在空白区域
        if (!_con.is(e.target) && _con.has(e.target).length === 0) {
          this.showDateDropdown = false;
          this.pledgeInfoDropdown = false;
        }
      },
      showPledgeDropdown() {
        if (this.pledgeInfoDropdown) {
          this.pledgeInfoDropdown = false;
        } else {
          this.pledgeInfoDropdown = true
        }
      },
      //日期筛选选择器
      showDateDropdownmenu: function() {
        if (this.showDateDropdown) {
          this.showDateDropdown = false;
        } else {
          this.showDateDropdown = true
        }
      },
      hide: function () {
        $('.company-menu').css('display', 'none')
        this.suggestion = []
        this.addedCPlist = []
      },
      // 检查是否存在创业板退市风险
      checkProperty: function (item) {
        if (Object.keys(item).indexOf('ctuishi') >= 0) {
          return true
        } else {
          return false
        }
      },
      setCnzz (name, action, label) {
        window._czc.push(['_trackEvent', name, action, label])
      },
      // 数组去重
      unique: function(arr) {
        var tmp = {}, ret = [];
        for (var i=0,len=arr.length; i<len; i++) {
          if (!tmp[arr[i]]) {    //如果tmp中没有this[i]
            tmp[arr[i]] = true;  //存入
            ret.push(arr[i]);   //添加到新数组中
          }
        }
        return ret;
      },
      showDropdown: function(type) {
        console.log(type);
        if (type == 'status') {
          if (this.dropdown_menu_status) {
            this.dropdown_menu_status = false;
          } else {
            this.dropdown_menu_status = true;
          }
        }

        if (type == 'timelimit') {
          if (this.dropdown_menu_timelimit) {
            this.dropdown_menu_timelimit = false;
          } else {
            this.dropdown_menu_timelimit = true;
          }
        }

        if (type == 'financinglist') {
          if (this.dropdown_menu_list_status) {
            this.dropdown_menu_list_status = false;
          } else {
            this.dropdown_menu_list_status = true;
          }
        }
      },
      hideDropdown: function(e) {
        if (this.dropdown_menu_status) {
          let _con = $('.dhy-strte-1')
          // 判断点击是否发生在空白区域
          if (!_con.is(e.target) && _con.has(e.target).length === 0) {
            this.dropdown_menu_status = false;
          }
        }

        if (this.dropdown_menu_timelimit) {
          let _con = $('.dhy-strte-2')
          // 判断点击是否发生在空白区域
          if (!_con.is(e.target) && _con.has(e.target).length === 0) {
            this.dropdown_menu_timelimit = false;
          }
        }

        if (this.dropdown_menu_list_status) {
          let _con = $('.dhy-strte-3')
          // 判断点击是否发生在空白区域
          if (!_con.is(e.target) && _con.has(e.target).length === 0) {
            this.dropdown_menu_list_status = false;
          }
        }
      },
      // 单选框选择
      radioClick(e) {
        var cName = $(e.target).attr('class');
        if (cName == 'el-radio-inner' || cName == 'el-radio-original') {
          var parentNode = $(e.target).parent('.el-radio-input');
          if (!parentNode.hasClass('is-checked')) {
            $('span.el-radio-input').removeClass('is-checked');
            parentNode.addClass('is-checked');
          }
        }
      },
      timeStyleChange: function (nowdate) {
        let Y = nowdate.getFullYear() + '-'
        let M = (nowdate.getMonth() + 1 < 10 ? '0' + (nowdate.getMonth() + 1) : nowdate.getMonth() + 1) + '-'
        let D = nowdate.getDate()
        console.log(Y + M + D);
        return Y + M + D
      },
      // 获取当前时间，格式YYYY-MM-DD
      getNowFormatDate() {
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();

        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;

        return currentdate;
      },
      //两个日期间隔多少天
      getDateDiff(startDate, endDate) {
       var startTime = new Date(Date.parse(startDate.replace(/-/g,   "/"))).getTime();
       var endTime = new Date(Date.parse(endDate.replace(/-/g,   "/"))).getTime();
       var dates = Math.abs((startTime - endTime))/(1000*60*60*24);

       return dates;
      },
      toWan(num) {
        return num = num > 9999 ? num/10000 : num;
      },
      showSharePriceDropdown() {
        if (this.financing.edit.companycode=='') {
          alert('请先输入证券代码');
          return;
        }
        let companycode = this.financing.edit.companycode.trim();
        if (companycode.length != 6) {
          alert('请输入有效证券代码');
          return;
        }
        this.sharePriceDropdown = this.sharePriceDropdown ? false : true;
      },
      hideSharePriceDropdown(e) {
        let _con = $('.dhy-gujia-dropdown-menu')
        // 判断点击是否发生在空白区域
        if (!_con.is(e.target) && _con.has(e.target).length === 0) {
          this.sharePriceDropdown = false;
        }
      },
      // 判断有几位小数
      decimalCount: function(num) {
        if (!num) { return; }

        //是小数
        if (String(num).indexOf('.') > 0) {
          var x = String(num).indexOf('.') + 1;   //小数点的位置
          var y = String(num).length - x;  //小数的位数
          if (y > 0) {
            console.log(y);
            return y;
          }
        } else { //不是小数
          return 0;
        }
      },
    },
    computed: {
      totalPage () {
        let totalPage = Math.ceil(this.total / this.perPage)
        return totalPage
      },
      indexs () {
        let left = 1
        let right = this.totalPage
        let ar = []
        if (this.totalPage >= 11) {
          if (this.page > 5 && this.page < this.totalPage - 4) {
            left = this.page - 5
            right = this.page + 4
          } else {
            if (this.page <= 5) {
              left = 1
              right = 10
            } else {
              right = this.totalPage
              left = this.page - 9
            }
          }
        }
        while (left <= right) {
          ar.push(left)
          left++
        }
        return ar
      },
    },
  }
</script>

<style scoped>
  .rate-chart-wrap {
    border: 1px solid rgb(232, 238, 245);
    padding: 0.2rem;
    background: #fff;
    margin-bottom: 0.5rem;
    overflow: hidden;
  }

  /* 加载更多 */
  .more,
  .more_top {
    height: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333;
  }

  .pull_icon,
  .pull_icon_top {
    width: 25px;
    height: 25px;
    /*background-image: url('../images/pull.png');*/
    /*background-image: url('../../../static/images/pull.png');*/
    background-repeat: no-repeat;
    background-position: center;
    background-size: 25px;
    transition: all .5s;
  }

  .more span,
  .more_top span {
    padding-left: .5rem;
  }

  .more .flip,
  .more_top .flip {
    transform: rotate(180deg);
  }

  .loading{
    /*background-image: url('../images/loading.png');*/
    background-image: url('../../../static/images/loading.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 25px;
  }

  .more .loading,
  .more_top .loading {
    -webkit-transform: rotate(0deg) translateZ(0);
    -webkit-transition-duration: 0;
    -webkit-animation-name: loading;
    -webkit-animation-duration: 2s;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;
  }

  .lszy-box .swiper-slide {
    height: 425px !important;
  }

  .ljzy-box .swiper-slide {
    height: 492px !important;
  }

  .lszy-box .pledge-list-box,
  .ljzy-box .pledge-list-box {
    padding: 0.2rem 0;
  }

  .lszy-box .pledge-list-box ul,
  .ljzy-box .pledge-list-box ul {
    margin: 0 2%;
  }

  /*加载动画*/
  .loading-box {
    top: 43% !important;
  }
  .loading-img {
    width: 35px;
    height: 35px;
    background-image: url('../../../static/images/loading2.gif');
    background-size: cover;
  }

  .more-wrapper {
    display: block;
    position: fixed;
    top: 0;
    /*min-height: 100%;*/
    /*overflow-y: scroll;*/
  }
  .more-wrapper .search-result-box {
    overflow-y: scroll;
  }
</style>



/** WEBPACK FOOTER **
 ** StockPledge.vue?15ab698e
 **/